import { render, staticRenderFns } from "./CreativeTargetIcon.vue?vue&type=template&id=edf0bd60&scoped=true"
import script from "./CreativeTargetIcon.vue?vue&type=script&lang=js"
export * from "./CreativeTargetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf0bd60",
  null
  
)

export default component.exports